import { render, staticRenderFns } from "./MyUserHistory.vue?vue&type=template&id=33a715b1&"
import script from "./MyUserHistory.vue?vue&type=script&lang=js&"
export * from "./MyUserHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports